<template>
	<div style="margin: 0 0 0 0;">
		<!-- Card -->
		<el-card class="box-card trace">
			<!-- Header -->
			<div slot="header">
				<el-row>
					<!-- Left -->

					<!-- Title -->
					<el-col :span="24">
						<div style="line-height: 2.5rem; font-size: 1.5rem;margin-bottom: 20px">轨迹管理</div>
					</el-col>
					<!-- Right -->
				</el-row>
				<el-row>

							<el-col :span="5">
								<el-select clearable :disabled="deptdisable" filterable @change="selectChanged2" v-model="form.dept" placeholder="请选择大队">
									<el-option v-for="item in depts" :key="item.bmid" :label="item.bmmc" :value="item.bmid"></el-option>
								</el-select>

							</el-col>
					<el-col :span="5">
						<el-select @change="changeIndex" clearable :disabled="childdeptdisable"  v-model="form.childBmid" placeholder="请选择班组">
							<el-option v-for="item in childDepts" :key="item.bmid" :label="item.bmmc" :value="item.bmid"></el-option>
						</el-select>
					</el-col>
<!--							<el-col :span="4">-->
<!--								<el-select  @change="changeIndex" clearable v-model="form.postpoint" placeholder="请选择岗点">-->
<!--									<el-option v-for="item in gdxx" :key="item.gdid" :label="item.gdmc" :value="item.gdid"></el-option>-->
<!--								</el-select>-->
<!--							</el-col>-->
							<el-col :span="5">
								<el-input  @change="changeIndex"
										  placeholder="请输入姓名"
										  v-model="form.name"
										  clearable>
								</el-input>
							</el-col>
					<el-col :span="4">
						<el-button type="primary" @click="selectChanged()">查询</el-button>
					</el-col>
				</el-row>
			</div>

			<el-table :data="userList" v-loading="loading" style="text-align: center; width: 100%;">
				<el-table-column prop="username" label="用户编号"></el-table-column>
				<el-table-column prop="name" label="用户名"></el-table-column>
				<el-table-column label="手机号码" prop="sjhm"></el-table-column>
				<el-table-column label="部门" prop="dept">
					<template slot-scope="scope">
						<span>{{getBm(scope.row)}}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-row>
							<el-button type="text" @click="showTrace(scope.row.userid)">查看轨迹</el-button>

						</el-row>
					</template>
				</el-table-column>
			</el-table>


			<el-pagination background layout="total, prev, pager, next" :total="total" @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>

			<trace-map v-if="visible" ref="traceMap" ></trace-map>
		</el-card>
	</div>
</template>

<script>
	import store from "../../../store";
	import TraceMap from './trace-map'
	export default {
		data() {
			return {
				loading: true, // 表格加载动画
				userList: [], // 用户列表
				currentPage: 1, // 当前页码
				total: 0, // 用户列表总数
				username: '', // 模糊搜索用户
				xzyhModal: false, // 新增用户模态框
				xzyh: { // 新增用户信息
					username: '', // 用户名
					xm: '', // 姓名
					xb: '', // 性别
					sfzhm: '', // 身份证号码
					zw: '', //职位
				},
				visible:false,
				gdxx:[],
				depts:[],
				childDepts:[],
				form:{
					dept:'',
					postpoint:'',
					username: '',
					childBmid:''
				},
				deptdisable:false,
				childdeptdisable:false,
				bmxx:[],
				gdxx: {},
				zwxx: {},
				userbm: '',
				usergd: '',
				userbc: [],
				bjyhModal: false, // 编辑用户模态框
				bjyh: {}, // 编辑用户信息
				dictionaryData: [],
				dddbz: [],


			}
		},
		components:{
			TraceMap
		},
		mounted() {
			this.getgdxx();
			this.getbmxx();
			// this.getbcxx();
			// this.getzwxx();
			this.getDept();


		},
		methods: {
			getBm(user) {
				var ubmid ;
				var bmmc;
				if(user.ddbz)  ubmid= user.ddbz;
				else ubmid = user.zzdyqc
				for(var i=0; i<this.bmxx.length;i++) {

					if(this.bmxx[i].bmid == ubmid) {
						bmmc = this.bmxx[i].bmmc
					}
				}
				if(bmmc) return bmmc;
				else {
					for(var i=0; i<this.bmxx.length;i++) {

						if(this.bmxx[i].bmid == user.zzdyqc) {
							return  this.bmxx[i].bmmc
						}
					}
				}
			},

			getbmxx() {
				let that = this;
				this.$request.get('/bjba/yhgl/getbmxx').then(res => {
					console.log("bmxx:", res);
					that.bmxx = res.data;
				})
			},
			changeIndex() {
				this.currentPage = 1
			},
			showTrace(id) {
				this.$router.push({path:'/bjba/trace/map',
					query:{id:id}});
			},
			getDept(){
				let user=store.getters.user;
				this.$request.get('/bjba/kqtj/getFirstMentForUser',{
					params: {
						userid:this.$store.getters.username
					}

				}).then(res => {
					this.depts = res.data
					if(this.depts && this.depts[0]) {

						var zzdyqc = this.$store.getters.user.zzdyqc;
						if(zzdyqc){
							if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
								var zw = this.$store.getters.user.zw;

								if(zw) {
									if(zw=='01'||zw=='02'||zw=='03') {
										this.form.dept = this.depts[0].bmid
										this.deptdisable = true
										if(zw !='01') {
											this.childdeptdisable =true;
										}
										this.selectChanged2(this.dept)
									}
									this.selectChanged2(this.dept)
								}
							}

						} else {this.selectChanged2(this.dept)}
						this.selectChanged2(this.dept)
						this.getUserList()
					}
				})
			},
			getgdxx() {
				let that = this;
				this.$request.get('/bjba/yhgl/getgdxx').then(res => {
					console.log("gdxx:", res)
					that.gdxx = res.data;
				})
			},
			selectChanged(value) {
				this.getUserList()
			},
			selectChanged2(value) {
				this.childDepts = []
				this.childDept =''
				this.currentPage = 1
				this.$request({
					method: 'get',
					url: '/bjba/kqtj/getMentForUser2',
					params: {
						fbmid: value,
						userid:this.$store.getters.username
					}
				}).then((response) => {
					this.childDepts = response.data;
					var zzdyqc = this.$store.getters.user.zzdyqc;
					if(zzdyqc){
						if(zzdyqc != this.CONST_ZN_BM) {
							var zw = this.$store.getters.user.zw;

							if(zw) {
								if(zw=='02'||zw=='03') {
									if(this.childDepts[0]) {
										this.form.childBmid = this.childDepts[0].bmid

									}
								}
							}
						}

					}
				}).catch((err) => {
					console.log(err)
				})
			},
			// 分页获取用户列表
			getUserList() {
				this.loading = true
				console.log(this.loading)
				const {
					username,
					currentPage
				} = this
				this.$request.get('/bjba/yhgl/findUserPageByParams', {
					params: {
						userid: this.$store.getters.username,
						username: this.form.name,
						page: currentPage,
						size: 10,
						dept:this.form.dept,
						postpoint:this.form.postpoint,
						childBmid: this.form.childBmid
					}

				}).then(res => {
					const {
						data
					} = res
					console.log("列表数据：", data)
					this.userList = data.data.list
					this.total = data.data.counts;
					//this.total = data.totalElements
					this.loading = false
				}).catch(err => {
					this.$message({
						message: '获取用户列表出现异常!',
						type: 'error',
						center: true,
						showClose: true
					})
					this.loading = false
					console.log(err)
				})
			},
			// 切换页码
			pageUser(page) {
				this.currentPage = page
				this.getUserList()
			},
			showUser(user) {
				this.$router.push({path:'/bjba/grzx',
				query:{username:user.USERNAME}});
			},

		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
